import { graphql } from '../../gql';

export const SKILL_TAXONOMIES_LEVELS_QUERY = graphql(`
  query SkillTaxonomiesLevels {
    selectionList {
      skill_taxonomies {
        labels_by_level {
          tag
          label
          level_id
        }
      }
    }
  }
`);
